import { Popover, PopoverTrigger, PopoverContent } from "../components/ui/popover";

export default function TestPage() {
  return (
    <div className="p-20">
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" className="border-b border-dotted border-red-500">Test Popover</button>
        </PopoverTrigger>
        <PopoverContent>
          <p>It works!</p>
        </PopoverContent>
      </Popover>
    </div>
  );
}
